import React from "react";
import { useBreakpoints } from "../../../hooks";
import { NavigationConfigType } from "../../../types";
import HorizontalNavigation from "./horizontal/HorizontalNavigation";
import { MobileNavigation } from "./mobile";

type NavigationProps = {
  config: NavigationConfigType;
  vertical?: boolean;
};

const Navigation: React.FC<NavigationProps> = ({ config, vertical = false }) => {
  const { isMobile } = useBreakpoints();
  if (isMobile) {
    return <MobileNavigation config={config} />;
  } else if (vertical) {
    return <div />;
  } else {
    return <HorizontalNavigation config={config} />;
  }
};

export default Navigation;
